export default function EyeDisabled() {
  return (
    <div
      className="ion-icon-eye-disabled"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<path class="st0" d="M376.4,158.3L448,86.6L425.4,64l-77.6,77.6C320,127.7,289.5,119,256,119c-81.9,0-145.7,52.2-224,137
	c34.8,37.4,66.8,72.7,103.3,98.1L64,425.4L86.6,448l76.9-76.9c27,13.7,57,21.9,92.5,21.9c99.9,0,173.4-81.8,224-135.5
	C452,223.4,417.6,185.7,376.4,158.3z M166.4,256c0-50.4,40.2-91.3,89.6-91.3c19.3,0,37.2,6.2,51.8,16.9l-50.7,50.7
	c-0.7-2.6-1.1-5.4-1.1-8.3c0-7.9,2.9-15.1,7.6-20.7c-2.5-0.4-5-0.6-7.6-0.6c-28.8,0-52.3,23.9-52.3,53.3c0,8.6,2,16.8,5.6,24
	L182,307.4C172.2,292.7,166.4,275,166.4,256z M256,347.3c-19.3,0-37.2-6.2-51.8-16.9l27.4-27.4c7.3,4,15.6,6.2,24.4,6.2
	c28.8,0,52.3-23.9,52.3-53.3c0-2.3-0.2-4.6-0.4-6.9c-5.5,4.3-12.3,6.9-19.8,6.9c-2.9,0-5.6-0.4-8.3-1.1l50.3-50.3
	c9.8,14.6,15.6,32.3,15.6,51.4C345.6,306.4,305.4,347.3,256,347.3z"/>
</svg>
`,
      }}
    />
  )
}
